import React, { useEffect, useState } from 'react';
import { callApiWithAuthorization } from '../../API/CallApi';

function useGetProjects(organizationId) {
    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        getProjects();
    }, []);

    async function getProjects() {
        try {
            const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/projects");
            const projects = await request.json();
            setProjects(projects);
        } catch (e) {
            console.log("--------------------------------");
            console.log("Error: " + e.message);
            console.log("Stack: " + e.stack);
            console.log("--------------------------------");
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }

    return [loading, projects, error];
}

export default useGetProjects;